export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',md:12,ms:12,block:{ms:12}}}